import {
  AppstoreAddOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  FolderOutlined,
  GoldOutlined,
  ProjectOutlined,
  SettingOutlined,
  TagOutlined,
  WalletOutlined
} from "@ant-design/icons";
import { LogOut } from "react-feather";
export const MENUITEMS = [
  {
    menutitle: "Applications",
    Items: [
      {
        title: "Project Dashboard",
        icon: <AppstoreAddOutlined />,
        type: "link",
        active: window?.location?.pathname == "/project-dashboard",
        path: `/project-dashboard`,
        inner: true,
        outer: false,
      },
      {
        title: "Budget",
        icon: <WalletOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/project/budget",
        path: `/app/project/budget`,
        inner: true,
        outer: false,
      },
      {
        title: "Po/Wo",
        icon: <FileTextOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/project/powo",
        path: `/app/project/powo`,
        inner: true,
        outer: false,
      },
      {
        title: "Biddings",
        icon: <TagOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/project/biddings",
        path: `/app/project/biddings`,
        inner: true,
        outer: false,
      },
      {
        title: "Project",
        icon: <ProjectOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/project/project-list",
        path: `/app/project/project-list`,
        inner: false,
        outer: true,
      },
      {
        title: "Vendors",
        icon: <GoldOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/vendor/vendor-list",
        path: `/app/vendor/vendor-list`,
        inner: true,
        outer: true,
      },
      {
        title: "Approvals",
        icon: <CheckCircleOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/approval/approvals",
        path: `/app/approval/approvals`,
        inner: true,
        outer: true,
      },
      {
        path: `/app/files`,
        icon: <FolderOutlined />,
        title: "Project Files",
        type: "link",
        inner: true,
        outer: false,
        active: window?.location?.pathname == "/app/files",
      },
      // {
      //   title: "Explore",
      //   icon: <SearchOutlined />,
      //   type: "link",
      //   active: window?.location?.pathname == "/app/ecommerce/product",
      //   path: `/app/ecommerce/product`,
      //   inner: true,
      //   outer: true,
      // },
      // {
      //   title: "Organisation",
      //   icon: Settings,
      //   type: "link",
      //   active: false,
      //   path: `/app/organisation`,
      //   inner: true,
      //   outer: true,
      // },
      {
        title: "Settings",
        icon: <SettingOutlined />,
        type: "link",
        active: window?.location?.pathname == "/app/project/project-settings",
        path: `/app/project/project-settings`,
        inner: true,
        outer: false,
      },

      {
        title: "Logout",
        icon: LogOut,
        type: "logout",
        active: false,
        // path: `/app/project/project-settings`,
        inner: false,
        outer: true,
      },
    ],
  },
];
